const Roles = [
  {
    id: "ADMIN",
    name: "Admin",
  },
];

export default Roles;
